import { useParams } from 'react-router-dom';
import { useQueryParams } from '@insurancemenu/imenu-components-lib';

interface Props {
  groupId: string;
  periodId: string;
  cartId: string;
}

const useEnrollmentQuoteUrlParams = (): Props => {
  const { periodId } = useParams<{ periodId: string }>();

  const query = useQueryParams();
  const cartId = query.get('cartId') || '';
  const groupId = query.get('groupId') || '';

  return { groupId, periodId, cartId };
};

export default useEnrollmentQuoteUrlParams;
